import { render } from "./UserListView.vue?vue&type=template&id=00364ab2&ts=true"
import script from "./UserListView.vue?vue&type=script&lang=ts"
export * from "./UserListView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__